var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconHelpOutlined(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6 27.65V29.85H20.4V27.65H22.6ZM7.35 21.5C7.35 13.6893 13.6893 7.35 21.5 7.35C29.3107 7.35 35.65 13.6893 35.65 21.5C35.65 29.3107 29.3107 35.65 21.5 35.65C13.6893 35.65 7.35 29.3107 7.35 21.5ZM9.55 21.5C9.55 28.0878 14.9122 33.45 21.5 33.45C28.0878 33.45 33.45 28.0878 33.45 21.5C33.45 14.9122 28.0878 9.55 21.5 9.55C14.9122 9.55 9.55 14.9122 9.55 21.5ZM20.4087 25.5C20.4566 24.5607 20.6973 23.8666 21.0291 23.3181C21.4042 22.6982 21.9086 22.2422 22.4422 21.8197C22.5625 21.7245 22.6866 21.6294 22.8117 21.5336C23.2238 21.218 23.6466 20.894 23.979 20.5293C24.4328 20.0314 24.75 19.4295 24.75 18.6C24.75 16.8117 23.2883 15.35 21.5 15.35C19.8299 15.35 18.4447 16.6249 18.2688 18.25H16.061C16.2413 15.4021 18.6064 13.15 21.5 13.15C24.5112 13.15 26.95 15.5888 26.95 18.6C26.95 20.2396 25.9862 21.1423 24.8945 22.0975C24.8566 22.1308 24.8184 22.1641 24.78 22.1975C23.8162 23.0386 22.7567 23.9632 22.6158 25.5H20.4087Z",
    fill: "black",
    fillOpacity: 0.87,
    stroke: "white",
    strokeWidth: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHelpOutlined);
export default __webpack_public_path__ + "static/media/icon-help-outlined.bce48c55c688d1bcdc04ad900439ed0b.svg";
export { ForwardRef as ReactComponent };